export default {
    mobileConversionConfig: {
        nestOverlayingSiblings: false,
        stackLayout: true,
        structuralItem: true
    }
}
